import React from 'react';
import { useTranslation } from 'react-i18next';
import { GoogleConsentCookieBanner } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

const CookieLazy = () => {
  const { t } = useTranslation();
  return (
    <GoogleConsentCookieBanner
      title=""
      manualText={t('cookie.manual')}
      acceptAllText={t('cookie.acceptAll')}
      acceptSelectionText={t('cookie.acceptSelection')}
      onlyNecessaryText={t('cookie.acceptOnlyNecessary')}
      cookieLevels={[
        {
          value: 'necessary',
          label: t('cookie.categories.necessary.label'),
          subLabel: t('cookie.categories.necessary.subLabel'),
          description: t('cookie.categories.necessary.description'),
          disabled: true,
          consentOptions: ['security_storage'],
        },
        {
          value: 'preferences',
          label: t('cookie.categories.preferences.label'),
          description: t('cookie.categories.preferences.description'),
          disabled: false,
          consentOptions: ['functionality_storage', 'personalization_storage'],
        },
        {
          value: 'statistics',
          label: t('cookie.categories.statistics.label'),
          description: t('cookie.categories.statistics.description'),
          disabled: false,
          consentOptions: ['analytics_storage'],
        },
        {
          value: 'marketing',
          label: t('cookie.categories.marketing.label'),
          description: t('cookie.categories.marketing.description'),
          disabled: false,
          consentOptions: ['ad_personalization', 'ad_user_data', 'ad_storage'],
        },
      ]}
      defaultValues={{
        necessary: true,
        preferences: false,
        statistics: false,
        marketing: false,
      }}
    >
      <h3>{t('cookie.header')}</h3>
      <p>{t('cookie.description')} <CoreLink to="/toelichting-cookies">Lees meer</CoreLink></p>
    </GoogleConsentCookieBanner>
  );
};

export default CookieLazy;
